
import React , {useEffect, useState} from 'react';

import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { FaAd , FaRegUserCircle, FaRegUser ,FaDollarSign , FaTree , FaSignOutAlt, FaClock } from "react-icons/fa";
// import BatabLogo from '../assets/logo_batabApp.png'
import BatabLogo from '../assets/just_logo.png'


import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

import UserToken from '../Infra/GetUserToken'; // Import UserToken to check authentication

const CustomNav‌bar = ()=>{

        const { t, i18n } = useTranslation();
        const navigate = useNavigate(); // Initialize useNavigate

        const [currentUserToken,setCurrentUserToken] = useState(UserToken() || null)

        const changeLanguage = (lng) => {
         i18n.changeLanguage(lng);
        };
    
        useEffect(() => {
        document.documentElement.dir = i18n.language === 'fa' || i18n.language === 'ar' ? 'rtl' : 'ltr';
        }, [i18n.language]);
        

        const getCssByDirection = (rtlClass,ltrClass)=>{
           return  i18n.language === 'fa' || i18n.language === 'ar' ? rtlClass : ltrClass;
        };

        const redirectToSearch = () => {
            const query = document.querySelector('input[type="search"]').value;
            if (query) {
                navigate(`/plants/search/${encodeURIComponent(query)}`); 
                // window.location.href = `/plants/search/${encodeURIComponent(query)}`;
            }
        }

    return (

        <Navbar expand="lg" className="bg-body-tertiary">
        <Container fluid>
            <Navbar.Brand href="/"> 
            <img src={BatabLogo} alt='logo' width={36} />
            {' '}
            <b> {t('appname')}  </b>
           </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="me-auto my-2 my-lg-0"
              style={{ maxHeight: '100px' }}
              navbarScroll
            >
              {/* <Nav.Link href="/"> {t('menu.home')} </Nav.Link> */}
              {/* <Nav.Link href="#profile"> {t('menu.profile')}  </Nav.Link> */}

            
            </Nav>

          

                <Form className="d-flex">
                <Form.Control
                    type="search"
                    placeholder={t('menu.search')} 
                    className="ms-2 "
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                           e.preventDefault(); // Prevent form submission

                            redirectToSearch();
                        }
                    }}
                    aria-label={t('menu.search')} 
                />
                {' '}
                <Button variant="outline-success" className='ms-2'
                onClick={() => redirectToSearch()}
                > {t('menu.search')}   </Button>
                </Form>

            <Nav>

                  { currentUserToken && <NavDropdown  title={ <FaRegUserCircle/> } className='d-flex custom-navbar-mbs' id="navbarScrollingDropdown">


{/* 
              <NavDropdown.Item href="#profile" 
             onClick={() => navigate('/profile')}
             className={getCssByDirection('text-end','text-start')}>
                 <FaRegUser/> {t('menu.profile')} 
              </NavDropdown.Item>
             */}


            <NavDropdown.Item href="#reminders"   
              onClick={() => navigate('/reminders')}
              className={getCssByDirection('text-end','text-start')}>
                <FaClock/> {t('dashboard.reminder')} 
              </NavDropdown.Item>


              <NavDropdown.Item href="#payment" 
                onClick={() => navigate('/payments')}
              className={getCssByDirection('text-end','text-start')}>
                 <FaDollarSign/> {t('menu.payment')} 
              </NavDropdown.Item>

              <NavDropdown.Item href="#plans"   
              onClick={() => navigate('/plans')}
              className={getCssByDirection('text-end','text-start')}>
                <FaTree/> {t('menu.plans')} 
              </NavDropdown.Item>

    

              <NavDropdown.Divider />
              <NavDropdown.Item href="#profile">
            
            
              
                <Button variant={`${i18n.language == 'en' ?'primary' :'outline-secondary' }`} onClick={() => changeLanguage('en')} title='English'> EN </Button>{' '}
                <Button variant={`${i18n.language == 'fa' ?'primary' :'outline-secondary' }`} onClick={() => changeLanguage('fa')} title='فارسی'> فا </Button>{' '}
                <Button variant={`${i18n.language == 'ar' ?'primary' :'outline-secondary' }`} onClick={() => changeLanguage('ar')} title='العربی'>  عر  </Button>


              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="/logout"  className={getCssByDirection('text-end','text-start')}> 
                <FaSignOutAlt/>    {t('menu.logout')} 
              </NavDropdown.Item>
           </NavDropdown>
           }


                  { !currentUserToken && 
                  <NavDropdown  title={ <FaRegUserCircle/> } className='d-flex custom-navbar-mbs' id="navbarScrollingDropdown">


 

              <NavDropdown.Item href="#plans"   
              onClick={() => navigate('/plans')}
              className={getCssByDirection('text-end','text-start')}>
                <FaTree/> {t('menu.plans')} 
              </NavDropdown.Item>

    

              <NavDropdown.Divider />
              <NavDropdown.Item href="#languages">
            
            
              
                <Button variant={`${i18n.language == 'en' ?'primary' :'outline-secondary' }`} onClick={() => changeLanguage('en')} title='English'> EN </Button>{' '}
                <Button variant={`${i18n.language == 'fa' ?'primary' :'outline-secondary' }`} onClick={() => changeLanguage('fa')} title='فارسی'> فا </Button>{' '}
                <Button variant={`${i18n.language == 'ar' ?'primary' :'outline-secondary' }`} onClick={() => changeLanguage('ar')} title='العربی'>  عر  </Button>


              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="/login"  className={getCssByDirection('text-end','text-start')}> 
                <FaSignOutAlt/>    {t('menu.login_register')} 
              </NavDropdown.Item>
           </NavDropdown> }


            

           
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

    );
};


export default CustomNav‌bar;